var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import FileUpload from "~/components/common/file-upload.vue";
import { PageService } from "~/utils/page.service";
import { OutsourceReconciliationManageService } from "~/services/domain-service/outsource-reconciliation-manage.service";
import { Emit } from 'vue-property-decorator';
// @Auth(414)
var BillCheck = /** @class */ (function (_super) {
    __extends(BillCheck, _super);
    function BillCheck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.importLoading = false;
        return _this;
    }
    BillCheck.prototype.refreshData = function () { };
    BillCheck.prototype.close = function () {
        this.refresh();
    };
    /**
     * 确认核对
     */
    BillCheck.prototype.submit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message('请先上传文件');
            return;
        }
        if (this.fileList.length > 1) {
            this.$message('请最多上传一个文件');
            return;
        }
        var fileId = this.fileList[0].response.id;
        this.outsourceReconciliationService.checkBill(fileId).subscribe(function (data) {
            _this.$message.success('核对成功');
            _this.refreshData();
            _this.close();
        });
    };
    BillCheck.prototype.refresh = function () {
        var fileUpload = this.$refs['file-upload'];
        fileUpload.reset();
    };
    __decorate([
        Dependencies(PageService)
    ], BillCheck.prototype, "pageService", void 0);
    __decorate([
        Dependencies(OutsourceReconciliationManageService)
    ], BillCheck.prototype, "outsourceReconciliationService", void 0);
    __decorate([
        Emit('refreshData')
    ], BillCheck.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], BillCheck.prototype, "close", null);
    BillCheck = __decorate([
        Layout('workspace'),
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], BillCheck);
    return BillCheck;
}(Vue));
export default BillCheck;
